// This function will copy the session of mobile web (session_id) to pc web (PHPSESSID).
import cookie from './cookie';
import { getChatHostname } from './hostnameUtil';

export const copySessionToPcWeb = () => {
  const session_id = cookie.getCookie('session_id');
  const PHPSESSID = cookie.getCookie('PHPSESSID');

  const SESSION_EXPIRE_SECOND = 60 * 60 * 24 * 14;

  if (session_id && !PHPSESSID) {
    const { chatHostName } = getChatHostname();

    const isSecure = window.location.protocol === 'https:';
    if (isSecure) {
      document.cookie = `PHPSESSID=${session_id}; expires=${new Date(
        Date.now() + SESSION_EXPIRE_SECOND * 1000
      ).toUTCString()}; domain=${'.' + chatHostName}; path=/; SameSite=None; secure;`;
    } else {
      document.cookie = `PHPSESSID=${session_id}; expires=${new Date(
        Date.now() + SESSION_EXPIRE_SECOND * 1000
      ).toUTCString()}; domain=${'.' + chatHostName}; path=/;`;
    }
  }
};

export const redirectWithAuth = (redirectedInstanceUrl) => {
  const mbId = cookie.getCookie('mb_id');
  const sessionId = cookie.getCookie('session_id');

  // If user is logged in, redirect with auth parameter to inform redirected instance
  // that need show user alert that they need to re-login in case they are not logged in
  if (mbId && sessionId) {
    window.location.href = `${redirectedInstanceUrl}?authed=1`;
  } else {
    // One or both values missing, redirect without auth parameter
    window.location.href = redirectedInstanceUrl;
  }
};

export const combineRedirectWithAuth = (redirectedInstanceUrl) => {
  const mbId = cookie.getCookie('mb_id');
  const sessionId = cookie.getCookie('session_id');

  // If user is logged in, redirect with auth parameter to inform redirected instance
  // that need show user alert that they need to re-login in case they are not logged in
  if (mbId && sessionId) {
    return `${redirectedInstanceUrl}?authed=1`;
  }

  return redirectedInstanceUrl;
};
